var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.effectiveStatus)?_c('span',[_c('span',{staticClass:"tag",class:_vm.tagClass},[_vm._v(" "+_vm._s(_vm.label)+" ")])]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }